const initialState = {
	menuVisible: false,
	entity: {},
	x: 0,
	y: 0
};


export default {
	state: {
		...initialState
	},

	mutations: {

		toggle (state, args) {
			if (args) {
				[ state.entity, state.x, state.y ] = args;
				state.menuVisible = true;
			} else {
				for (let prop in initialState) {
					state[prop] = initialState[prop];
				}
			}
		}

	},

	namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogue/actions.js